export default function emptyLib() {
  return `
    <div class="empty-lib">
        <h1 class="empty__text">The library is empty. Please add movies</h1>
        
        <button type="button" class="header__btn header__btn--empty btn-active">Back to Home</button>
        
    </div>`;
}
